import { putResolve, put } from "@redux-saga/core/effects";
import axios from "axios";

import { FormsService, GetFormResponse } from "./../../../services/forms";

import { GetFormRequestActionType, IForm } from "./../types";
import {
    setCurrentForm,
    getFormFailure,
    getUserFontsRequest,
    setFormStyles,
    initFormButtons,
    getFormSuccess,
} from "./../actionCreators";
import {
    completeFieldsData,
    completeFormButtonsStyles,
    completeFormSetting,
    completeFormStyles,
    getCompletedPaymentData,
} from "../../../helpers/dataManipulations";
import { IErrorType } from "./../../types/errors.d";
import { InitPages } from "./../../pages/actionCreators";
import { initFields } from "./../../fields/actionCreators";
import { initLayout } from "./../../layout/actionCreators";
import { initMarkers } from "../../markers/actionCreaters";
import { InitLogic } from "../../logic/actionCreators";
import { initConfigs } from "./../../configs/actionCreators";
import { initOptions } from "./../../selectableOptions/actionCreaters";
import { initUI } from "./../../ui/actionCreators";
import { initValidationMessages } from "../../validations/actionCreators";
import { getDeclarablePaymentData } from "../../../helpers/paymentActions";
import { initFormSettings } from "../../settings/actionCreators";
import { getDeclarableFormButtonsData } from "../../../helpers/submitButton";
import { initPayableFields, initPaymentData } from "../../payment/actionCreators";

export function* getFormSaga({ payload: { id } }: GetFormRequestActionType) {
    try {
        const {
            data: { data },
        }: GetFormResponse = yield FormsService.getForm(id);
        yield putResolve(
            setCurrentForm({
                _id: data._id,
                name: data.name,
                status: data.status,
                createdAt: data.createdAt,
                updatedAt: data.updatedAt,
                integrations: data.integrations,
            } as IForm),
        );

        yield putResolve(initFormSettings(completeFormSetting(data.settings)));
        yield putResolve(setFormStyles(completeFormStyles(data.styles)));
        yield putResolve(InitPages({ list: data.pages }));

        yield putResolve(initFields({ list: completeFieldsData(data.fields) }));
        yield putResolve(initLayout(data.layout));
        yield putResolve(initMarkers({ list: data.fields }));
        yield putResolve(initUI({ isPaginationActive: data.isPaginationActive, isVerticalView: data.isVerticalView }));
        yield putResolve(initOptions({ list: data.fields }));
        yield putResolve(InitLogic(data.logic));
        yield putResolve(initConfigs(data));

        yield put(getUserFontsRequest({}));
        yield putResolve(initValidationMessages(data.validations));
        yield putResolve(initPayableFields({ list: data.fields, paymentSettings: data.paymentSettings! }));
        yield putResolve(initFormButtons(getDeclarableFormButtonsData(completeFormButtonsStyles(data.styles.buttons))));
        yield putResolve(
            initPaymentData(
                getDeclarablePaymentData(getCompletedPaymentData(data.paymentSettings ? data.paymentSettings : {})),
            ),
        );
        yield put(getFormSuccess({ ownerId: data.userId }));
    } catch (error) {
        console.log("Error", error);
        if (axios.isAxiosError(error))
            yield put(getFormFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(getFormFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
